<script>
import { forEach } from 'lodash';

import Constants from '../constants';
import hoverDesign from '@/components/hoverDesign';

export default {
  name: 'cdSliderDiamond',
  components: {
    hoverDesign,
  },
  data() {
    return {
      cdList: [],
      selectCdIndex: 0,
      ready: false,
      isDestroy: false,
      timer: 5000,
      onChange: false,
    };
  },
  created() {
    this.cdList = [];
    forEach(this.$t('message.discography.albums'), (v) => {
      this.cdList.unshift(v);
    });
    setTimeout(()=> {
      this.ready = true;
      this.selectCdIndexChangeTimer();
    }, 1);
  },
  beforeDestroy() {
    this.isDestroy = true;
  },
  methods: {
    moveToAlbumPage(id) {
      this.$router.push({ name: Constants.ROUTER[`ALBUM${id}`], });
    },
    selectCdIndexChangeTimer() {
      setTimeout(() => {
        this.timer -= 1000;
        if (!this.isDestroy) {
          if (this.timer <= 0) {
            this.selectCdIndexToNext();
          }
          this.selectCdIndexChangeTimer();
        }
      }, 1000);
    },

    selectCdIndexToNext() {
      if (this.onChange) { return; }
      this.timer = 5000;
      this.onChange = true;
      setTimeout(() => {
        if (this.selectCdIndex >= this.cdList.length - 1) {
          this.selectCdIndex = 0;
        } else {
          this.selectCdIndex += 1;
        }
      }, 300);
      setTimeout(() => {
        this.onChange = false;
      }, 1000);
    },
    changeCdIndex(index) {
      if (this.onChange) { return; }
      this.timer = 5000;
      this.onChange = true;
      setTimeout(() => {
        this.selectCdIndex = index;
      }, 300);
      setTimeout(() => {
        this.onChange = false;
      }, 1000);
    },
  },
};
</script>

<template>
  <div class="cd-slider-diamond" v-if="ready" :class="onChange ? 'on-change': ''">
    <div class="cd-jacket" @click="moveToAlbumPage(cdList[selectCdIndex].id)"
      :class="`is-album-jacket-${cdList[selectCdIndex].id}`"
    >
      <div class="bg-around a1" :class="`is-album-jacket-${cdList[selectCdIndex].id}`"></div>
      <div class="bg-around a2" :class="`is-album-jacket-${cdList[selectCdIndex].id}`"></div>
      <div class="bg-around a3" :class="`is-album-jacket-${cdList[selectCdIndex].id}`"></div>
      <div class="bg-around a4" :class="`is-album-jacket-${cdList[selectCdIndex].id}`"></div>
      <div class="jacket-centar">
        <div class="bg" :class="`is-album-jacket-${cdList[selectCdIndex].id}`"></div>
      </div>
      <hover-design hover-design="horizonSquare"/>
    </div>
    <div class="cd-slider-menu">
      <div class="click-item" 
        v-for="(cdItem, index) in cdList" :key="cdItem.id"
        @click="changeCdIndex(index)"
      >
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .cd-slider-diamond {
    height: 100%;
    width: 100%;
    max-height: 400px;
    overflow: hidden;
    cursor: pointer;
    position: relative;
    @include flexCenter;

    .cd-jacket {
      width: 100vh;
      height: 100vh;
      max-height: 400px;
      max-width: 400px;
      @include flexCenter;
      background-size: contain;
      position: relative;
      overflow: hidden;
      .bg-around {
        display: none;
        position: absolute;
        width: 100%;
        height: 100%;
        margin: -100% 0 0 -100%;
        background-size: contain;
        background-position: 200px 200px;
        &.a1 {margin: -100% 0 0 -100%;}
        &.a2 {margin: -100% 0 0 100%;}
        &.a3 {margin: 100% 0 0 -100%;}
        &.a4 {margin: 100% 0 0 100%;}
      }
      .jacket-centar {
        width: 70.71%;
        height: 70.71%;
        background: gray;
        transform: rotate(45deg);
        @include flexCenter;
        overflow: hidden;
        display: none;
        .bg {
          width: 141.4%;
          min-width: 141.4%;
          height: 141.4%;
          transform: rotate(-45deg);
          background-size: contain;
        }
      }
    }

    &.on-change {
      .cd-jacket {
        .bg-around {
          display: block;
          animation: changeAnime2 1s ease 0s infinite;
        }
        .jacket-centar {
          display: flex;
          .bg {
            animation: changeAnime1 1s ease 0s infinite;
          }
        }
      }
    }

    @keyframes changeAnime1 {
      0% {transform: rotate(-45);}
      100% {transform: rotate(-765deg);}
    }
    @keyframes changeAnime2 {
      0% {transform: rotate(0);}
      100% {transform: rotate(-720deg);}
    }

    // menu--------------------
    .cd-slider-menu {
      height: 20px;
      width: 400px;
      position: absolute;
      bottom: 0;
      display: flex;
      justify-content: space-around;
      .click-item {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background: $textColor;
        cursor: pointer;
        transition: 0.2s ease;
        &:hover {
          transform: scale(1.5);
          filter: drop-shadow(0px 0px 5px $accentColor2);
        }
      }
    }
  }
</style>
